export default {
	api: 'https://csoconnect.ust.hk/cso/api',
	loginTimeout: 86400
};
